/* Card photos are prepared only for the visible, active gallery. */
(function(win, doc) {
  var states = new WeakMap();
  function visible(root) {
    if (!root || !root.isConnected || doc.hidden || root.closest('[hidden], [aria-hidden="true"].Drawer')) return false;
    var style = win.getComputedStyle(root);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    var rect = root.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < win.innerHeight && rect.right > 0 && rect.left < win.innerWidth;
  }
  function request(image, priority) {
    if (!image) return;
    if (priority && image.getAttribute('fetchpriority') !== 'high') image.setAttribute('fetchpriority', priority);
    image.loading = 'eager';
    if (image.dataset.cardPhotoRequested === 'true') return;
    image.dataset.cardPhotoRequested = 'true';
    if (win.lazySizes && win.lazySizes.loader && typeof win.lazySizes.loader.unveil === 'function' && image.dataset.src) {
      win.lazySizes.loader.unveil(image);
    } else {
      if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
      if (image.dataset.src) image.src = image.dataset.src.replace('{width}', String(Math.ceil(image.getBoundingClientRect().width || 600)));
    }
  }
  function cancel(root) {
    var state = states.get(root);
    if (state && state.cleanup) state.cleanup();
    states.delete(root);
  }
  function prepare(root, slides, index, ahead, wrap) {
    if (!visible(root) || !slides.length) return;
    index = Math.min(slides.length - 1, Math.max(0, index));
    var selected = slides[index].querySelector('img');
    var old = states.get(root);
    if (old && old.selected === selected && old.index === index && old.ahead === ahead && (old.cleanup || old.warmed)) return;
    cancel(root);
    var state = { selected: selected, index: index, ahead: ahead };
    states.set(root, state);
    function neighbours() {
      if (state.cleanup) { state.cleanup(); state.cleanup = null; }
      if (states.get(root) !== state || !visible(root)) return;
      state.warmed = true;
      if (!ahead) return;
      var connection = win.navigator.connection || win.navigator.mozConnection || win.navigator.webkitConnection;
      var restricted = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''));
      var offsets = restricted ? [1] : [1, 2, -1];
      var seen = new Set([index]);
      offsets.forEach(function(offset) {
        if (offset < 0 && index === 0) return;
        var next = index + offset;
        if (wrap) next = (next + slides.length) % slides.length;
        if (next < 0 || next >= slides.length || seen.has(next)) return;
        seen.add(next);
        request(slides[next].querySelector('img'), 'low');
      });
    }
    if (!selected) { neighbours(); return; }
    request(selected, 'auto');
    if (selected.complete && (selected.naturalWidth > 0 || /^(?!data:).+/.test(selected.getAttribute('src') || ''))) { neighbours(); return; }
    selected.addEventListener('load', neighbours, {once:true});
    selected.addEventListener('error', neighbours, {once:true});
    state.cleanup = function() {
      selected.removeEventListener('load', neighbours);
      selected.removeEventListener('error', neighbours);
    };
  }
  win.DsrcvCardPhotos = {prepare:prepare, request:request, cancel:cancel};
})(window, document);

/* Shared mobile product-card drag/settle behaviour, matching cart media. */
(function(win, doc) {
  var query = win.matchMedia('(max-width: 1007px)');
  var states = new Map();
  var gestures = new Map();
  var lastModelMode = !!(doc.body && doc.body.classList.contains('model-image-active'));
  function bind(node) {
    if (!query.matches || !node) return false;
    if (states.has(node)) return true;
    var cells = Array.from(node.querySelectorAll('.Carousel__Cell'));
    if (cells.length < 2) return false;
    var instance = win.Flickity && typeof win.Flickity.data === 'function' && win.Flickity.data(node);
    // Preserve desktop hooks on their original instance across breakpoints.
    var suspendedInstance = instance && typeof instance.deactivate === 'function' && typeof instance.activate === 'function' ? instance : null;
    if (suspendedInstance) suspendedInstance.deactivate();
    else if (instance && instance.destroy) instance.destroy();
    var originalStyle = node.getAttribute('style');
    var originalCellStyles = cells.map(function(cell) { return cell.getAttribute('style'); });
    if (!suspendedInstance) {
      node.productCardCarousel = null;
      node.buyItWithCarousel = null;
      delete node.dataset.productCardBound;
    }
    node.replaceChildren.apply(node, cells);
    node.classList.remove('flickity-enabled', 'is-draggable');
    node.classList.add('MobileProductMedia');
    node.dataset.mobileMediaBound = 'true';
    var wrapper = node.closest('.ProductItem__ImageCarouselWrapper') || node;
    var root = node.closest('.product-image-container-main');
    var modelImage = root && root.querySelector('.model-image-container img');
    var progress = wrapper.querySelector('[data-product-card-progress], [data-buy-it-with-progress], [data-buy-it-with-carousel-progress]');
    var controller = new AbortController();
    var options = { signal: controller.signal };
    var start = null;
    var dragged = false;
    var blockedUntil = 0;
    var currentIndex = 0;
    var settleTarget = null;
    var syncedIndex = -1;
    var syncedGestureCell = null;
    var cellVideos = cells.map(function(cell) { return Array.from(cell.querySelectorAll('video')); });
    var pendingVideos = new WeakSet();
    var frame = null;
    var observer;
    var visibilityObserver;
    var hasPhotoIntent = false;
    var cancelSelectionWait = null;
    var pendingPhotoTarget = null;
    var selectionRequest = 0;
    function cancelPendingSelection() {
      selectionRequest += 1;
      pendingPhotoTarget = null;
      if (cancelSelectionWait) cancelSelectionWait();
      cancelSelectionWait = null;
    }
    var decodedPhotos = new WeakMap();
    function decodePhoto(image) {
      var src = image.currentSrc || image.src;
      var state = decodedPhotos.get(image);
      if (!state || state.src !== src) {
        state = {src:src, ready:false};
        decodedPhotos.set(image, state);
        state.promise = image.decode().then(function() { state.ready = true; });
        state.promise.catch(function() {});
      }
      return state.promise;
    }
    function photoReady(index) {
      var image = cells[index] && cells[index].querySelector('img');
      if (!image) return true;
      if (!image.complete || image.naturalWidth < 1) return false;
      if (typeof image.decode !== 'function') return true;
      decodePhoto(image);
      return decodedPhotos.get(image).ready;
    }
    function imagePath(image) {
      if (!image) return '';
      var src = image.currentSrc || image.getAttribute('src') || image.dataset.src;
      if (!src || /^data:/.test(src)) return '';
      try { return new win.URL(src, doc.baseURI).pathname.replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[^.]+$)/i, ''); }
      catch (error) { return ''; }
    }
    function modelIndex() {
      var id = (modelImage.getAttribute('data-model-media-id') || '').split('/').pop();
      var path = imagePath(modelImage);
      var index = id ? cells.findIndex(function(cell) {
        return (cell.getAttribute('data-media-id') || '').split('/').pop() === id;
      }) : -1;
      if (index < 0 && path) index = cells.findIndex(function(cell) {
        return imagePath(cell.querySelector('img')) === path;
      });
      return Math.max(0, index);
    }
    function applyViewMode() {
      cancelPendingSelection();
      if (root) delete root.dataset.productCardSwipingMedia;
      if (modelImage) {
        currentIndex = doc.body.classList.contains('model-image-active') ? modelIndex() : 0;
        select(currentIndex, true, false);
      }
      sync();
    }
    function point(event) {
      var touches = event.changedTouches && event.changedTouches.length ? event.changedTouches : event.touches;
      if (!touches) return event;
      if (start && start.touchId !== undefined) {
        return Array.from(touches).find(function(touch) { return touch.identifier === start.touchId; }) || null;
      }
      return touches[0] || null;
    }
    function warm(index) {
      hasPhotoIntent = true;
      win.DsrcvCardPhotos.prepare(node, cells, index, true, false);
    }
    function sync(force) {
      if (frame) win.cancelAnimationFrame(frame);
      frame = null;
      if (!node.clientWidth) return;
      currentIndex = Math.min(cells.length - 1, Math.max(0, Math.round(node.scrollLeft / Math.max(node.clientWidth, 1))));
      if (settleTarget !== null && Math.abs(node.scrollLeft - settleTarget * node.clientWidth) <= 1) {
        settleTarget = null;
        node.classList.remove('is-settling');
      }
      var gestureCell = start && start.cell;
      if (force !== true && currentIndex === syncedIndex && gestureCell === syncedGestureCell) return;
      syncedIndex = currentIndex;
      syncedGestureCell = gestureCell;
      if (hasPhotoIntent) warm(currentIndex);
      var rect = cellVideos.some(function(videos) { return videos.length; }) ? node.getBoundingClientRect() : null;
      node.dataset.nativeSearchSelectedIndex = String(currentIndex);
      cells.forEach(function(cell, i) {
        var active = i === currentIndex;
        cell.classList.toggle('is-selected', active);
        // Keep the original touch/focus target available until the gesture ends.
        var gestureTarget = start && cell === start.cell;
        cell.setAttribute('aria-hidden', active || gestureTarget ? 'false' : 'true');
        cell.inert = !active && !gestureTarget;
        cellVideos[i].forEach(function(video) {
          if (!active || doc.hidden || !rect.width || !rect.height || rect.bottom <= 0 || rect.top >= win.innerHeight) {
            video.pause(); return;
          }
          var src = video.getAttribute('data-video-src');
          if (src && !video.getAttribute('src')) video.src = src;
          video.querySelectorAll('source[data-src]').forEach(function(s) { if (!s.src) s.src = s.dataset.src; });
          video.muted = true;
          if (video.paused && !pendingVideos.has(video)) {
            pendingVideos.add(video);
            var play = video.play();
            if (play && play.catch) play.catch(function() {}).finally(function() { pendingVideos.delete(video); });
            else pendingVideos.delete(video);
          }
        });
      });
      if (progress) {
        progress.hidden = false;
        progress.style.setProperty('--product-card-progress-count', cells.length);
        progress.style.setProperty('--product-card-progress-index', currentIndex);
        progress.setAttribute('data-product-card-progress-count', cells.length);
        progress.setAttribute('data-product-card-progress-index', currentIndex);
      }
    }
    function select(index, instant, hydrate) {
      index = Math.max(0, Math.min(cells.length - 1, index));
      cancelPendingSelection();
      if (hydrate !== false && hasPhotoIntent) {
        warm(index);
        if (!photoReady(index)) {
          pendingPhotoTarget = index;
          var image = cells[index].querySelector('img');
          var token = selectionRequest;
          function loaded() {
            if (!image.complete || image.naturalWidth < 1) return;
            image.removeEventListener('load', loaded);
            var ready = typeof image.decode === 'function' ? decodePhoto(image) : Promise.resolve();
            ready.then(function() {
              if (token !== selectionRequest || !node.isConnected || !query.matches) return;
              if (root) root.dataset.productCardSwipingMedia = 'true';
              select(index, true);
            }, cancelWait);
          }
          function cancelWait() { if (token === selectionRequest) cancelPendingSelection(); }
          image.addEventListener('load', loaded);
          image.addEventListener('error', cancelWait, {once:true});
          cancelSelectionWait = function() {
            image.removeEventListener('load', loaded);
            image.removeEventListener('error', cancelWait);
          };
          // Stay on the last visible photo while a cold destination loads.
          node.classList.remove('is-settling');
          settleTarget = null;
          node.scrollTo({left: currentIndex * node.clientWidth, behavior: 'instant'});
          loaded();
          return;
        }
        if (root) root.dataset.productCardSwipingMedia = 'true';
      }
      var immediate = instant || win.matchMedia('(prefers-reduced-motion: reduce)').matches;
      settleTarget = immediate ? null : index;
      // Let the explicit settle own its destination, without an intermediate snap.
      node.classList.toggle('is-settling', !immediate);
      node.scrollTo({ left: index * node.clientWidth, behavior: immediate ? 'instant' : 'smooth' });
    }
    function reset(keepSnapDisabled) {
      if (start && start.pointerId !== undefined) {
        gestures.delete(start.pointerId);
        if (node.hasPointerCapture && node.hasPointerCapture(start.pointerId)) {
          try { node.releasePointerCapture(start.pointerId); } catch (error) {}
        }
      }
      if (keepSnapDisabled) node.classList.add('is-settling');
      start = null; node.classList.remove('is-dragging'); sync();
    }
    function down(event) {
      // Use the touch stream on phones; mouse/pen keep pointer capture/routing.
      if (event.pointerType === 'touch' && 'ontouchstart' in win) return;
      if (event.touches && event.touches.length > 1) {
        if (start && start.touchId !== undefined) reset();
        return;
      }
      if (event.button && event.button !== 0 || start) return;
      cancelPendingSelection();
      // A quick second swipe starts from the last requested photo, not halfway
      // through the browser's previous smooth-scroll animation.
      if (settleTarget !== null) select(settleTarget, true, false);
      // Read the actual position, including a previous swipe that just settled.
      if (modelImage && root.dataset.productCardSwipingMedia !== 'true') applyViewMode();
      else sync();
      var p = point(event);
      if (!p) return;
      start = { x: p.clientX, y: p.clientY, left: node.scrollLeft, index: currentIndex, pointerId: event.pointerId, touchId: p.identifier, cell: event.target.closest('.Carousel__Cell') || cells[currentIndex] };
      dragged = false;
      sync();
      node.dispatchEvent(new CustomEvent('product-card:manual-media-intent', { bubbles: true }));
      if (event.pointerId !== undefined) gestures.set(event.pointerId, { move: move, end: end, cancel: cancel });
    }
    function move(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      if (event.touches && event.touches.length > 1) { reset(); return; }
      var p = point(event);
      if (!p) return;
      var dx = p.clientX - start.x, dy = p.clientY - start.y;
      if (!dragged && Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx)) { reset(); return; }
      if (!dragged && Math.abs(dx) >= 12 && Math.abs(dx) > Math.abs(dy) * 1.1) {
        dragged = true;
        warm(currentIndex);
        // Capturing on pointerdown would redirect a normal link tap to the track.
        if (event.pointerId !== undefined && node.setPointerCapture) {
          try { node.setPointerCapture(event.pointerId); } catch (error) {}
        }
      }
      if (!dragged) return;
      var target = Math.max(0, Math.min(cells.length - 1, start.index + (dx < 0 ? 1 : -1)));
      if (!photoReady(start.index) || !photoReady(target)) {
        win.DsrcvCardPhotos.request(cells[target].querySelector('img'));
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
        return;
      }
      node.classList.add('is-dragging');
      if (root) root.dataset.productCardSwipingMedia = 'true';
      if (event.cancelable) event.preventDefault();
      event.stopPropagation();
      node.scrollLeft = start.left - dx;
      scheduleSync();
    }
    function end(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      var p = point(event);
      if (!p) return;
      var dx = p.clientX - start.x;
      sync();
      var target = dragged && Math.abs(dx) >= 34 ? start.index + (dx < 0 ? 1 : -1) : currentIndex;
      if (dragged) {
        blockedUntil = Date.now() + 500;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      var didDrag = dragged;
      reset(didDrag);
      if (didDrag) select(target);
    }
    function cancel(event) {
      if (!start || event.pointerId !== start.pointerId) return;
      if (start.touchId !== undefined && !point(event)) return;
      sync();
      var didDrag = dragged;
      var target = currentIndex;
      if (didDrag) {
        blockedUntil = Date.now() + 500;
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
      }
      reset(didDrag);
      if (didDrag) select(target);
    }
    function listen(name, fn, passive) { node.addEventListener(name, fn, { signal: controller.signal, capture: true, passive: passive }); }
    // Linked photos must stay with the gallery rather than starting a native drag.
    listen('dragstart', function(event) { event.preventDefault(); }, false);
    if (win.PointerEvent) {
      listen('pointerdown', down, true);
    }
    listen('touchstart', down, true); listen('touchmove', move, false); listen('touchend', end, false); listen('touchcancel', cancel, false);
    node.addEventListener('product-card:media-enhanced', function() {
      // A desktop media request may complete after crossing into mobile.
      // Adopt appended slides without cancelling the shopper's current gesture.
      Array.from(node.querySelectorAll('.Carousel__Cell')).forEach(function(cell) {
        if (cells.indexOf(cell) >= 0) return;
        originalCellStyles.push(cell.getAttribute('style'));
        cells.push(cell);
        cellVideos.push(Array.from(cell.querySelectorAll('video')));
      });
      sync(true);
    }, options);
    node.addEventListener('product-card:view-change', function() {
      reset();
      applyViewMode();
    }, options);
    function scheduleSync() {
      if (!frame) frame = win.requestAnimationFrame(function() { frame = null; sync(); });
    }
    doc.addEventListener('visibilitychange', function() { sync(true); }, options);
    node.addEventListener('scroll', scheduleSync, { passive: true, signal: controller.signal });
    wrapper.addEventListener('click', function(event) {
      if (Date.now() < blockedUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, { capture: true, signal: controller.signal });
    node.addEventListener('keydown', function(event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        hasPhotoIntent = true;
        event.preventDefault(); select(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, options);
    var nav = root && Array.from(root.querySelectorAll('[data-product-card-nav]')).find(function(element) {
      return element.getAttribute('data-product-card-nav') === node.id;
    });
    if (nav) nav.addEventListener('click', function(event) {
      var button = event.target.closest('button[data-direction]');
      if (!button || !nav.contains(button) || button.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
      hasPhotoIntent = true;
      var direction = button.getAttribute('data-direction') === 'prev' ? -1 : 1;
      var fromIndex = pendingPhotoTarget !== null ? pendingPhotoTarget : settleTarget === null ? currentIndex : settleTarget;
      select((fromIndex + direction + cells.length) % cells.length);
    }, {capture: true, signal: controller.signal});
    if (win.ResizeObserver) {
      var width = node.clientWidth;
      observer = new ResizeObserver(function() {
        if (node.clientWidth === width) return;
        width = node.clientWidth; select(currentIndex, true);
      });
      observer.observe(node);
    }
    if (win.IntersectionObserver) {
      visibilityObserver = new win.IntersectionObserver(function() { sync(true); }, { threshold: 0.1 });
      visibilityObserver.observe(node);
    }
    states.set(node, { viewChange: applyViewMode, destroy: function() {
      cancelPendingSelection();
      win.DsrcvCardPhotos.cancel(node);
      reset(); controller.abort(); if (observer) observer.disconnect(); if (visibilityObserver) visibilityObserver.disconnect(); if (frame) win.cancelAnimationFrame(frame);
      node.querySelectorAll('video').forEach(function(video) { video.pause(); });
      node.classList.remove('MobileProductMedia', 'is-dragging', 'is-settling'); delete node.dataset.mobileMediaBound;
      if (originalStyle === null) node.removeAttribute('style'); else node.setAttribute('style', originalStyle);
      cells.forEach(function(cell, i) {
        cell.inert = false; cell.removeAttribute('aria-hidden');
        if (originalCellStyles[i] === null) cell.removeAttribute('style'); else cell.setAttribute('style', originalCellStyles[i]);
      });
      node.scrollLeft = 0;
      states.delete(node);
      if (suspendedInstance && node.isConnected && !query.matches) {
        suspendedInstance.activate();
        suspendedInstance.resize();
        suspendedInstance.select(currentIndex, false, true);
      }
    } });
    applyViewMode();
    return true;
  }
  // One shared pointer route keeps a held gesture working across card boundaries.
  ['pointermove', 'pointerup', 'pointercancel'].forEach(function(type) {
    win.addEventListener(type, function(event) {
      var gesture = gestures.get(event.pointerId);
      if (gesture) gesture[type === 'pointermove' ? 'move' : type === 'pointerup' ? 'end' : 'cancel'](event);
    }, { capture: true, passive: false });
  });
  win.DsrcvMobileProductMedia = { bind: bind, enabled: function() { return query.matches; } };
  query.addEventListener('change', function() {
    if (!query.matches) states.forEach(function(state) { state.destroy(); });
    doc.dispatchEvent(new CustomEvent('dsrcv:mobile-media-change'));
  });
  new MutationObserver(function() {
    states.forEach(function(state, node) { if (!node.isConnected) state.destroy(); });
  }).observe(doc.documentElement, { childList: true, subtree: true });
  if (doc.body) new MutationObserver(function() {
    var modelMode = doc.body.classList.contains('model-image-active');
    if (modelMode === lastModelMode) return;
    lastModelMode = modelMode;
    states.forEach(function(state) { state.viewChange(); });
  }).observe(doc.body, { attributes: true, attributeFilter: ['class'] });
})(window, document);
